import { Element } from "@craftjs/core";
import { useBreakpointValue } from "@gluestack-style/react";
import { Box } from "components/ui";
import React from "react";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { PageContainer } from "./PageContainer";
import { PageText } from "./PageText";

export const TileListingDefaultProps = {};

export const PageTileListingTitle = (props: any) => {
	return (
		<Box
			style={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
			}}
		>
			{props.children}
		</Box>
	);
};
export const TileListingContainer = ({ ...props }) => {
	const cloneChildren = props.children.props.children;
	const [pageNumber, setPageNumber] = React.useState(1);

	// Number of columns based on screen size
	const noColumn = useBreakpointValue({
		base: 2,
		lg: 4,
	});
	const itemWidth = useBreakpointValue({
		base: "$full",
		md: "$1/2",
		lg: "$1/3",
	});
	const itemsPerPage = noColumn * 2;

	const pageCount = Math.ceil(cloneChildren ? cloneChildren.length : 1 / itemsPerPage);
	let currentPageItems = null;
	const onChangePage = (newPage: number) => {
		setPageNumber(newPage);
	};
	if (cloneChildren) {
		currentPageItems = cloneChildren.slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage);
	}
	const isMobile = useIsMobile();
	const itemHeight = 426;
	const gap = 8;
	const numberOfRows = Math.ceil(currentPageItems ? currentPageItems.length : 1 / noColumn);
	const totalGapSpace = (numberOfRows - 1) * gap;
	const dynamicHeight = numberOfRows * itemHeight + totalGapSpace;
	return (
		<PageContainer>
			<Box
				width="$full"
				sx={{
					width: "100%",
					flexDirection: "row",
					flexWrap: "wrap",
				}}
			>
				{cloneChildren.map((child: any, key: number) => {
					return (
						<Box key={key} width={itemWidth}>
							{child}
						</Box>
					);
				})}
			</Box>
		</PageContainer>
	);
};
export const PageTileListing = ({ background, ...props }: { background?: string; [key: string]: any }) => {
	const isMobile = useIsMobile();
	return (
		<Box paddingVertical={isMobile ? 12 : 48} bg={background || "transparent"} {...props}>
			<Element id="listing-title" className="card-list-title-container" is={PageTileListingTitle} data-cy="listing-title">
				<PageText text="Listing Title" fontSize={36} fontWeight="bold" />
			</Element>
			<Element canvas id="tile-listing-container" data-cy="tile-listing-container" is={TileListingContainer}></Element>
		</Box>
	);
};
